var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 2000,
    height: 2000,
    viewBox: "0 0 2000 2000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "rgb(25, 118, 210)",
    strokeWidth: 3,
    fill: "none",
    strokeDasharray: "15, 8",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("polyline", {
    points: " 861.506,1073.06 861.496,1059.99"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 861.496,1059.99 805.804,1028.05"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 861.496,1059.99 879.214,1049.81"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 879.214,1049.81 823.523,1017.87"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 879.214,1049.81 879.112,914.724"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 879.112,914.724 823.42,882.781"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 879.112,914.724 861.393,924.905"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 861.393,924.905 823.436,903.133"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 861.393,924.905 861.384,911.839"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 861.384,911.839 805.692,879.895"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 861.384,911.839 918.828,878.832"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 918.828,878.832 918.368,878.567"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 918.828,878.832 958.633,959.454"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 958.633,959.454 902.941,927.51"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 958.633,959.454 998.467,833.072"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 998.467,833.072 942.776,801.128"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 998.467,833.072 1055.82,800.118"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1055.82,800.118 1050.83,797.258"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1055.82,800.118 1055.83,813.184"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1055.83,813.184 1047.55,808.437"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1055.83,813.184 1044.2,819.866"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1038.03,840.897 1038.12,958.506"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1038.12,958.506 982.427,926.563"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1038.12,958.506 1055.93,948.272"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1055.93,948.272 1007.71,920.611"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1055.93,948.272 1055.93,952.768"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 984.321,1002.49 984.311,989.424"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 984.311,989.424 928.62,957.48"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 984.311,989.424 1002.03,979.243"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1002.03,979.243 946.338,947.3"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1002.03,979.243 1001.94,856.249"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1001.94,856.249 946.245,824.306"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1001.94,856.249 960.333,988.731"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 935.252,1007.03 892.176,919.316"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 892.176,919.316 836.485,887.373"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 892.176,919.316 892.224,982.346"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 892.254,1021.96 892.27,1042.31"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 892.27,1042.31 836.578,1010.37"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 892.27,1042.31 909.988,1032.13"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1220.16,866.978 1220.15,851.752"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1220.15,851.752 1164.46,819.809"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1220.15,851.752 1303.14,672.81"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1303.14,672.81 1247.45,640.867"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1303.14,672.81 1236.46,711.122"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1236.46,711.122 1219.4,701.337"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1236.46,711.122 1236.48,735.202"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1236.48,735.202 1210.59,720.349"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1236.48,735.202 1223.7,742.543"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1223.7,742.543 1205.21,731.936"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1223.7,742.543 1223.68,703.669"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1223.68,703.669 1167.98,671.725"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1223.68,703.669 1344.53,634.225"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1344.53,634.225 1320.95,620.698"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1344.53,634.225 1344.54,649.451"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1344.54,649.451 1320.96,635.924"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1344.54,649.451 1321.99,698.488"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1305.42,734.522 1262.49,827.858"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1262.49,827.858 1206.8,795.914"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1262.49,827.858 1332.8,787.456"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1332.8,787.456 1277.11,755.513"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1332.8,787.456 1332.78,764.888"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1332.78,764.888 1277.09,732.944"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1332.78,764.888 1345.56,757.547"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1424.77,1009.33 1424.76,994.107"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1424.76,994.107 1369.07,962.164"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1424.76,994.107 1507.75,815.165"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1507.75,815.165 1452.06,783.221"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1507.75,815.165 1441.07,853.476"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1441.07,853.476 1424.01,843.692"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1441.07,853.476 1441.09,877.557"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1441.09,877.557 1415.19,862.704"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1441.09,877.557 1428.31,884.898"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1428.31,884.898 1409.82,874.291"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1428.31,884.898 1428.28,846.024"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1428.28,846.024 1372.59,814.08"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1428.28,846.024 1549.14,776.58"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1510.03,876.877 1467.1,970.213"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1467.1,970.213 1411.4,938.269"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1467.1,970.213 1537.41,929.811"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1537.41,929.811 1481.72,897.868"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1537.41,929.811 1537.39,907.242"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1537.39,907.242 1481.7,875.299"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1537.39,907.242 1550.17,899.902"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 928.192,1294.66 928.182,1281.6"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 928.182,1281.6 872.491,1249.65"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 928.182,1281.6 945.901,1271.42"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 945.901,1271.42 890.209,1239.47"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 945.901,1271.42 945.798,1136.33"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 945.798,1136.33 890.107,1104.38"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 945.798,1136.33 928.08,1146.51"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 928.08,1146.51 890.123,1124.74"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 928.08,1146.51 928.07,1133.44"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 928.07,1133.44 872.379,1101.5"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 928.07,1133.44 985.515,1100.44"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 985.515,1100.44 985.054,1100.17"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 985.515,1100.44 1025.32,1181.06"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1025.32,1181.06 969.628,1149.11"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1025.32,1181.06 1065.15,1054.68"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1065.15,1054.68 1009.46,1022.73"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1065.15,1054.68 1122.5,1021.72"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1122.5,1021.72 1117.52,1018.86"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1122.5,1021.72 1122.51,1034.79"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1122.51,1034.79 1114.24,1030.04"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1122.51,1034.79 1110.89,1041.47"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1104.72,1062.5 1104.81,1180.11"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1104.81,1180.11 1049.11,1148.17"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1104.81,1180.11 1122.62,1169.88"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1122.62,1169.88 1074.39,1142.22"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1122.62,1169.88 1122.62,1174.37"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1051.01,1224.09 1051,1211.03"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1051,1211.03 995.307,1179.08"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1051,1211.03 1068.72,1200.85"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1068.72,1200.85 1013.02,1168.9"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1068.72,1200.85 1068.62,1077.85"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1068.62,1077.85 1012.93,1045.91"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1068.62,1077.85 1027.02,1210.33"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1001.94,1228.63 958.863,1140.92"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 958.863,1140.92 903.172,1108.98"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 958.863,1140.92 958.911,1203.95"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 958.941,1243.56 958.956,1263.91"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 958.956,1263.91 903.265,1231.97"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 958.956,1263.91 976.675,1253.73"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1294.49,1076.41 1294.46,1038.19"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1294.46,1038.19 1238.77,1006.24"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1294.46,1038.19 1306.3,1031.38"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1306.3,1031.38 1281.36,1017.08"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1306.3,1031.38 1308.14,1038.7 1308.91,1040.89 1309.73,1042.71 1310.46,1044 1311.21,1045.1 1312.04,1046.07 1313.06,1047.08 1314.17,1048 1315.28,1048.81 1316.57,1049.65 1319.1,1051.15"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1319.1,1051.15 1263.41,1019.2"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1319.1,1051.15 1324.87,1051.53 1327.81,1051.44 1329.86,1051.2 1332.12,1050.73 1334.77,1049.91 1337.6,1048.79 1340.81,1047.3 1346.99,1044.09"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1346.99,1044.09 1291.3,1012.14"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1346.99,1044.09 1354.71,1039.17 1358.87,1035.93 1362.48,1032.47 1365.76,1028.86 1368.99,1025.07"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1368.99,1025.07 1313.3,993.127"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1368.99,1025.07 1373.25,1017.36 1374.51,1014.37 1375.25,1011.95 1375.88,1008.81 1376.28,1005.43 1376.53,1002.05"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1376.53,1002.05 1320.84,970.106"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1376.53,1002.05 1376.34,999.211 1376.1,997.233 1375.85,995.955 1375.54,994.891 1375.24,994.132 1374.9,993.486 1374.47,992.838 1373.93,992.16 1373.33,991.536 1372.38,990.685 1371.39,989.878"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1371.39,989.878 1315.7,957.935"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1371.39,989.878 1366.05,989.22 1363.64,989.178 1361.16,989.382 1357.86,989.957 1354.06,990.899 1350.21,991.999"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1350.21,991.999 1329.32,998.062"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1329.32,998.062 1315.17,989.944"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1329.32,998.062 1323.3,999.562 1318.98,1000.41 1316.12,1000.77 1313.34,1000.89 1311.22,1000.78 1309.21,1000.48 1307.25,1000.04"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1300.59,997.775 1297.17,993.536 1295.82,991.447 1294.93,989.728 1294.31,988.21 1293.7,986.223 1293.27,984.259 1292.85,981.486 1292.47,976.795 1292.26,971.93"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1292.26,971.93 1236.57,939.987"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1292.26,971.93 1293.46,958.562 1294.67,952.255 1296.2,947.11 1299.02,940.193 1302.36,933.466 1305.99,926.718"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1305.99,926.718 1250.3,894.775"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1305.99,926.718 1317.9,911.999 1323.62,906.168 1330.09,900.796 1337.25,895.813 1344.54,891.226"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1344.54,891.226 1288.85,859.282"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1344.54,891.226 1357.29,884.523 1369.95,879"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1369.95,879 1314.26,847.057"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1369.95,879 1383.74,874.139 1397.33,870.4"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1397.35,901.175 1397.36,906.035"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1397.36,906.035 1395.57,905.012"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1397.36,906.035 1394.28,907.803"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1385.51,912.84 1383.81,906.395 1382.93,904.027 1382.14,902.41 1381.46,901.303 1380.76,900.371 1379.91,899.454 1378.96,898.604 1377.95,897.834 1376.87,897.118 1375.76,896.451"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1375.76,896.451 1373.65,895.295"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1373.65,895.295 1321.56,865.415"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1373.65,895.295 1368.7,895.167 1366.18,895.293 1364.31,895.524 1362.18,895.964 1360.26,896.528 1358.31,897.237"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1335.35,911.024 1331.02,915.333 1326.79,920.06"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1326.79,920.06 1313.44,912.406"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1326.79,920.06 1324.4,924.02 1322.84,926.922 1321.66,929.613 1320.97,931.794 1320.42,934.333 1320.01,937.507 1319.76,940.681"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1319.76,940.681 1284.76,920.607"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1319.76,940.681 1320.13,945.543 1320.37,946.868 1320.66,947.974 1320.95,948.753 1321.27,949.419 1321.68,950.09 1322.2,950.796 1322.78,951.45 1323.68,952.333 1324.62,953.175"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1324.62,953.175 1268.93,921.232"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1324.62,953.175 1330.65,953.714 1333.51,953.668 1336.67,953.306 1342.47,952.047 1348.41,950.363"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1348.41,950.363 1369.3,944.3"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1369.3,944.3 1313.61,912.357"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1369.3,944.3 1378.67,942.231 1381.44,941.886 1384.12,941.772 1386.04,941.87 1387.76,942.113 1390,942.647 1391.96,943.289 1394.72,944.405 1397.43,945.638"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1397.43,945.638 1381.08,936.259"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1397.43,945.638 1400.99,950.259 1402.4,952.523 1403.34,954.394 1403.99,956.026 1404.69,958.399 1405.17,960.685 1405.57,963.521 1405.86,966.834 1406.18,973.347"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1406.18,973.347 1372.77,954.184"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1406.18,973.347 1405.35,983.676 1404.59,988.852 1403.76,992.743 1402.65,996.643"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1171.07,1096.01 1214.25,1071.2"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1171.07,1096.01 1115.38,1064.07"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1214.25,1071.2 1158.56,1039.26"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1214.25,1071.2 1192.76,1021.87"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1192.76,1021.87 1137.06,989.925"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1192.76,1021.87 1171.07,1096.01"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1130.09,1178.66 1130.08,1165.59"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1130.08,1165.59 1074.39,1133.65"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1130.08,1165.59 1141.45,1159.05"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1141.45,1159.05 1085.76,1127.11"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1141.45,1159.05 1193.75,980.785"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1193.75,980.785 1138.06,948.842"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1193.75,980.785 1216.04,967.979"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1238.78,1018.97 1254.05,1053.22"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1259.54,1065.54 1268.65,1085.96"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1268.65,1085.96 1212.96,1054.02"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1268.65,1085.96 1281.89,1078.36"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1216.72,1128.88 1216.71,1115.81"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1216.71,1115.81 1161.02,1083.87"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1216.71,1115.81 1230.33,1107.99"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1230.33,1107.99 1174.63,1076.04"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1230.33,1107.99 1218.83,1081.64"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1218.83,1081.64 1163.14,1049.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1218.83,1081.64 1176.64,1105.89"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1159.67,1135.02 1154.88,1151.34"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1154.88,1151.34 1099.19,1119.39"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1154.88,1151.34 1171.48,1141.8"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1581.64,574.146 1593.86,567.126"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1581.64,574.146 1525.95,542.202"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1593.86,567.126 1538.17,535.183"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1593.86,567.126 1601.19,562.163 1604.22,559.596 1606.81,556.924 1610.45,552.336 1613.95,547.372"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1613.95,547.372 1558.26,515.429"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1613.95,547.372 1618.06,537.946 1619.3,534.098 1620.05,530.683 1620.43,528.111 1620.7,525.26 1620.97,519.894"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1620.97,519.894 1565.28,487.951"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1620.97,519.894 1620.44,512.52 1620.1,510.494 1619.67,508.793 1619.2,507.464 1618.67,506.332 1617.99,505.19 1617.2,504.103 1616.47,503.232 1615.61,502.302 1613.91,500.615"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1613.91,500.615 1558.22,468.672"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1613.91,500.615 1610.93,499.824 1609.41,499.532 1608.24,499.393 1606.95,499.343 1605.71,499.41 1604.58,499.578 1603.41,499.846 1602.23,500.203 1600.61,500.796 1597.24,502.316 1593.81,504.064"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1593.81,504.064 1565.27,487.693"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1593.81,504.064 1581.59,511.083"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1581.59,511.083 1563.91,500.94"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1581.59,511.083 1581.64,574.146"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1620.35,558.28 1625.31,556.684 1627.13,556.297 1628.35,556.148 1629.63,556.103 1631.5,556.211 1632.93,556.392 1634.34,556.613"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1620.35,558.28 1564.66,526.337"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1634.34,556.613 1578.65,524.67"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1634.34,556.613 1636,557.383 1637.6,558.224"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1649.13,573.279 1664.6,598.535"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1664.6,598.535 1608.91,566.592"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1664.6,598.535 1678.87,590.337"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1633.09,629.713 1610.86,593.765"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1610.86,593.765 1555.17,561.821"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1610.86,593.765 1607.83,588.575 1606.15,586.245 1605.02,584.944 1603.69,583.67 1601.82,582.178 1599.89,580.786"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1599.89,580.786 1544.19,548.842"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1599.89,580.786 1597.3,580.558 1595.98,580.573 1595.06,580.668 1594.15,580.845 1592.96,581.193 1591.74,581.657 1589.56,582.676 1587.34,583.835"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1587.34,583.835 1558.58,567.338"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1587.34,583.835 1581.65,587.104"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1581.65,587.104 1564.84,577.46"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1581.65,587.104 1581.66,600.215"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1581.68,625.604 1581.7,646.171"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1581.7,646.171 1526,614.228"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1581.7,646.171 1599.6,635.883"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1527.99,690.101 1527.98,677.035"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1527.98,677.035 1472.29,645.091"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1527.98,677.035 1545.79,666.8"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1545.79,666.8 1490.1,634.857"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1545.79,666.8 1545.69,531.713"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1545.69,531.713 1490,499.769"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1545.69,531.713 1527.88,541.947"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1527.88,541.947 1490.02,520.229"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1527.88,541.947 1527.87,528.881"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1527.87,528.881 1472.18,496.938"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1527.87,528.881 1607.32,483.228"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1607.32,483.228 1551.63,451.285"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1607.32,483.228 1620.49,476.561 1625.64,474.591 1629.09,473.642 1632.52,473.057 1636.6,472.769 1640.7,472.801 1644.77,472.999"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1644.77,472.999 1589.08,441.056"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1644.77,472.999 1647.66,474.567"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1627.75,552.573 1620.35,558.28"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1376.62,628.859 1358.9,639.039"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1376.62,628.859 1320.93,596.915"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1358.9,639.039 1320.95,617.268"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1358.9,639.039 1358.89,625.973"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1358.89,625.973 1303.2,594.03"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1358.89,625.973 1430.51,584.822"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1430.51,584.822 1428.3,583.554"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1430.51,584.822 1430.52,597.888"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1430.52,597.888 1428.31,596.62"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1430.52,597.888 1428.31,599.157"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1412.76,673.937 1412.77,688.786"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1412.77,688.786 1413.18,703.288 1413.88,709.048 1414.68,712.725 1415.73,715.994 1417.32,719.69 1419.07,723.037 1420.92,726.292"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1420.92,726.292 1365.23,694.349"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1420.92,726.292 1424.9,727.882 1426.94,728.5 1428.51,728.828 1429.72,728.978 1431.07,729.032 1432.35,728.964 1433.54,728.802 1434.75,728.553 1436.4,728.095 1438.3,727.432 1443.44,725.127 1448.72,722.364"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1448.72,722.364 1393.02,690.421"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1448.72,722.364 1457.93,716.302 1461.85,713.123 1464.41,710.659 1467.32,707.334 1471.76,701.176 1475.98,694.543"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1475.98,694.543 1420.29,662.6"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1475.98,694.543 1481.12,678.278 1482.54,671.758 1483.58,663.37 1483.95,655.567 1484.02,647.848"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1484.02,647.848 1483.96,567.185"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1483.96,567.185 1428.27,535.241"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1483.96,567.185 1466.24,577.365"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1466.24,577.365 1428.28,555.594"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1466.24,577.365 1466.23,564.299"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1466.23,564.299 1410.54,532.356"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1466.23,564.299 1514.72,536.436"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1514.72,536.436 1490.02,522.266"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1514.72,536.436 1514.73,549.502"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1514.73,549.502 1490.03,535.332"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1514.73,549.502 1496.92,559.737"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1496.92,559.737 1490.04,555.792"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1496.92,559.737 1496.98,642.668"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1496.98,642.668 1486.74,636.791"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1496.98,642.668 1496.54,656.731 1495.85,664.237 1494.77,671.043"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1390.62,756.286 1386.05,750.996 1383.95,748.178 1382.51,745.932 1381.1,743.308 1380,740.689 1379.19,738.162 1378.53,735.488 1377.86,731.721 1376.98,721.927 1376.68,711.574"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1376.68,711.574 1320.99,679.631"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1376.68,711.574 1376.62,628.859"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1104.39,874.408 1147.56,849.599"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1104.39,874.408 1048.7,842.464"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1147.56,849.599 1091.87,817.655"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1147.56,849.599 1126.07,800.264"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1126.07,800.264 1070.38,768.321"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1126.07,800.264 1104.39,874.408"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1063.4,957.051 1063.39,943.985"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1063.39,943.985 1007.7,912.042"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1063.39,943.985 1074.77,937.448"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1074.77,937.448 1019.08,905.505"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1074.77,937.448 1127.06,759.181"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1127.06,759.181 1071.37,727.237"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1127.06,759.181 1149.35,746.374"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1173.45,800.417 1201.97,864.361"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1201.97,864.361 1146.27,832.418"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1201.97,864.361 1215.21,856.752"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1215.21,856.752 1164.46,827.646"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1215.21,856.752 1215.21,864.141"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1150.03,907.273 1150.02,894.207"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1150.02,894.207 1094.33,862.263"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1150.02,894.207 1163.64,886.383"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1163.64,886.383 1107.95,854.44"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1163.64,886.383 1152.14,860.039"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1152.14,860.039 1096.45,828.096"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1152.14,860.039 1109.95,884.282"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1092.98,913.419 1088.2,929.732"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1088.2,929.732 1032.5,897.789"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1088.2,929.732 1104.8,920.194"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1343.08,1313.09 1287.39,1281.14"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 800.681,1497.71 812.204,1506.26 819.662,1511.19 827.312,1515.8"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 827.312,1515.8 846.068,1525.35 865.802,1533.05 886.449,1538.89 907.941,1542.83 930.207,1544.87 953.171,1544.99 976.759,1543.2 1000.89,1539.51 1025.49,1533.93 1050.47,1526.47 1075.75,1517.15 1101.24,1506.02 1135.43,1488.42 1173.91,1464.95 1212.15,1437.79 1249.85,1407.12 1286.74,1373.19 1315.33,1344.02 1343.08,1313.09"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1343.08,1313.09 1429,1356"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1029.42,1871.84 1029.42,1665.26"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1029.42,1665.26 973.728,1633.31"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 973.728,1680.52 1001.39,1673.83 1029.42,1665.26"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 707.625,1902 550.106,1809.87"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 550.106,1809.87 494.415,1777.93"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 550.106,1809.87 676.201,1591.47"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 676.201,1591.47 620.51,1559.53"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 595.14,1411.26 606.361,1457.21 619.662,1495.66 634.161,1527.71 650.989,1557.2 663.132,1574.92 676.201,1591.47"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 595.14,1411.26 539.449,1379.31"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 553.678,1435.04 595.14,1411.26"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 416.814,1513.54 416.814,1255.48"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 416.814,1255.48 361.123,1223.53"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 416.814,1255.48 595.14,1153.19"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 595.14,1153.19 539.449,1121.25"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 676.201,879.989 640.911,971.591 613.743,1063.15 595.14,1153.19"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 676.201,879.989 620.51,848.046"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 550.106,806.238 676.201,879.989"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 550.106,806.238 494.415,774.295"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 550.106,806.238 707.625,533.411"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 778.356,574.78 833.72,607.161"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 833.72,607.161 778.029,575.218"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1029.42,401.007 960.907,461.855 895.319,530.947 833.72,607.161"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1029.42,401.007 973.728,369.064"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1029.42,194.425 1029.42,401.007"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1029.42,194.425 973.728,162.482"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1029.42,194.425 1252.18,169.943"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1252.18,226.03 1252.18,273.235"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1252.18,273.235 1196.49,241.291"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1429,251.886 1401.34,249.601 1372.82,249.662 1343.56,252.067 1313.63,256.809 1283.14,263.872 1252.18,273.235"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1375.76,896.451 1320.07,864.508"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 827.312,1515.8 771.621,1483.85"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1350.21,991.999 1320.45,974.926"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1348.41,950.363 1292.72,918.42"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1412.77,688.786 1403.45,683.437"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1484.02,647.848 1428.33,615.905"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    stroke: "rgb(255, 255, 255)",
    strokeWidth: 15,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: " 861.506,1073.06 805.814,1041.12"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 805.804,1028.05 805.814,1041.12"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 823.523,1017.87 805.804,1028.05"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 823.42,882.781 823.523,1017.87"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 805.702,892.961 823.42,882.781"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 823.436,903.133 805.702,892.961"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 805.692,879.895 805.702,892.961"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 863.137,846.888 805.692,879.895"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 918.368,878.567 863.137,846.888"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 902.941,927.51 863.137,846.888"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 942.776,801.128 902.941,927.51"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1000.13,768.175 942.776,801.128"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1050.83,797.258 1000.13,768.175"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1000.14,781.241 1000.13,768.175"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1047.55,808.437 1000.14,781.241"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1044.2,819.866 1038.02,823.418"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 982.325,791.475 1000.14,781.241"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1038.02,823.418 982.325,791.475"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1038.02,823.418 1038.03,840.897"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 982.427,926.563 982.325,791.475"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1000.24,916.329 982.427,926.563"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1007.71,920.611 1000.24,916.329"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1055.93,952.768 1055.94,961.338"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1000.25,929.395 1000.24,916.329"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1055.94,961.338 1000.25,929.395"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1055.94,961.338 984.321,1002.49"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 928.63,970.546 1000.25,929.395"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 984.321,1002.49 928.63,970.546"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 928.62,957.48 928.63,970.546"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 946.338,947.3 928.62,957.48"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 946.245,824.306 946.338,947.3"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 960.333,988.731 958.845,993.469"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 903.154,961.526 946.245,824.306"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 958.845,993.469 903.154,961.526"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 958.845,993.469 935.252,1007.03"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 879.56,975.083 903.154,961.526"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 935.252,1007.03 879.56,975.083"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 836.485,887.373 879.56,975.083"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 892.224,982.346 892.254,1021.96"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 836.578,1010.37 836.485,887.373"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 854.296,1000.19 836.578,1010.37"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 909.988,1032.13 854.296,1000.19"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 909.988,1032.13 909.998,1045.2"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 854.306,1013.25 854.296,1000.19"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 909.998,1045.2 854.306,1013.25"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 909.998,1045.2 861.506,1073.06"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 805.814,1041.12 854.306,1013.25"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1220.16,866.978 1164.47,835.035"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1164.46,819.809 1164.47,835.035"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1247.45,640.867 1164.46,819.809"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1180.77,679.178 1247.45,640.867"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1219.4,701.337 1180.77,679.178"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1180.79,703.259 1180.77,679.178"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1210.59,720.349 1180.79,703.259"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1168.01,710.6 1180.79,703.259"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1205.21,731.936 1168.01,710.6"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1167.98,671.725 1168.01,710.6"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1288.84,602.282 1167.98,671.725"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1320.95,620.698 1288.84,602.282"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1288.85,617.508 1288.84,602.282"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1320.96,635.924 1288.85,617.508"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1321.99,698.488 1305.42,734.522"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1206.8,795.914 1288.85,617.508"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1277.11,755.513 1206.8,795.914"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1277.09,732.944 1277.11,755.513"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1289.87,725.603 1277.09,732.944"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1345.56,757.547 1289.87,725.603"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1345.56,757.547 1345.59,794.909"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1289.9,762.966 1289.87,725.603"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1345.59,794.909 1289.9,762.966"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1345.59,794.909 1220.16,866.978"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1164.47,835.035 1289.9,762.966"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1424.77,1009.33 1369.08,977.39"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1369.07,962.164 1369.08,977.39"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1452.06,783.221 1369.07,962.164"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1385.38,821.533 1452.06,783.221"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1424.01,843.692 1385.38,821.533"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1385.4,845.614 1385.38,821.533"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1415.19,862.704 1385.4,845.614"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1372.62,852.955 1385.4,845.614"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1409.82,874.291 1372.62,852.955"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1372.59,814.08 1372.62,852.955"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1493.45,744.637 1372.59,814.08"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1549.14,776.58 1493.45,744.637"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1549.14,776.58 1549.15,791.806"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1493.46,759.863 1493.45,744.637"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1549.15,791.806 1493.46,759.863"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1549.15,791.806 1510.03,876.877"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1411.4,938.269 1493.46,759.863"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1481.72,897.868 1411.4,938.269"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1481.7,875.299 1481.72,897.868"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1494.48,867.958 1481.7,875.299"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1550.17,899.902 1494.48,867.958"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1550.17,899.902 1550.2,937.264"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1494.51,905.321 1494.48,867.958"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1550.2,937.264 1494.51,905.321"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1550.2,937.264 1424.77,1009.33"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1369.08,977.39 1494.51,905.321"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 928.192,1294.66 872.501,1262.72"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 872.491,1249.65 872.501,1262.72"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 890.209,1239.47 872.491,1249.65"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 890.107,1104.38 890.209,1239.47"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 872.389,1114.57 890.107,1104.38"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 890.123,1124.74 872.389,1114.57"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 872.379,1101.5 872.389,1114.57"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 929.823,1068.49 872.379,1101.5"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 985.054,1100.17 929.823,1068.49"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 969.628,1149.11 929.823,1068.49"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1009.46,1022.73 969.628,1149.11"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1066.81,989.779 1009.46,1022.73"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1117.52,1018.86 1066.81,989.779"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1066.82,1002.85 1066.81,989.779"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1114.24,1030.04 1066.82,1002.85"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1110.89,1041.47 1104.7,1045.02"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1049.01,1013.08 1066.82,1002.85"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1104.7,1045.02 1049.01,1013.08"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1104.7,1045.02 1104.72,1062.5"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1049.11,1148.17 1049.01,1013.08"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1066.93,1137.93 1049.11,1148.17"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1074.39,1142.22 1066.93,1137.93"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1122.62,1174.37 1122.63,1182.94"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1066.94,1151 1066.93,1137.93"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1122.63,1182.94 1066.94,1151"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1122.63,1182.94 1051.01,1224.09"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 995.317,1192.15 1066.94,1151"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1051.01,1224.09 995.317,1192.15"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 995.307,1179.08 995.317,1192.15"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1013.02,1168.9 995.307,1179.08"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1012.93,1045.91 1013.02,1168.9"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1027.02,1210.33 1025.53,1215.07"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 969.84,1183.13 1012.93,1045.91"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1025.53,1215.07 969.84,1183.13"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1025.53,1215.07 1001.94,1228.63"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 946.247,1196.69 969.84,1183.13"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1001.94,1228.63 946.247,1196.69"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 903.172,1108.98 946.247,1196.69"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 958.911,1203.95 958.941,1243.56"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 903.265,1231.97 903.172,1108.98"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 920.983,1221.79 903.265,1231.97"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 976.675,1253.73 920.983,1221.79"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 976.675,1253.73 976.684,1266.8"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 920.993,1234.86 920.983,1221.79"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 976.684,1266.8 920.993,1234.86"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 976.684,1266.8 928.192,1294.66"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 872.501,1262.72 920.993,1234.86"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1294.49,1076.41 1238.8,1044.47"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1238.77,1006.24 1238.8,1044.47"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1250.61,999.439 1238.77,1006.24"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1281.36,1017.08 1250.61,999.439"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1263.41,1019.2 1260.17,1017.26 1258.64,1016.18 1257.55,1015.3 1256.44,1014.24 1255.6,1013.25 1254.89,1012.26 1254.25,1011.17 1253.67,1010.01 1253.16,1008.77 1252.54,1007.03 1251.51,1003.32 1250.61,999.439"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1291.3,1012.14 1281.44,1017.05 1278.82,1018.06 1276.26,1018.83 1274,1019.29 1271.52,1019.54 1268.73,1019.58 1266.06,1019.43 1263.41,1019.2"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1313.3,993.127 1306.37,1000.96 1303.18,1003.98 1299.1,1007.17 1295.22,1009.75 1291.3,1012.14"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1320.84,970.106 1320.18,976.982 1319.59,979.879 1319.01,981.869 1317.89,984.704 1315.75,988.913 1313.3,993.127"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1315.7,957.935 1317.25,959.234 1317.98,959.938 1318.48,960.508 1318.98,961.184 1319.35,961.799 1319.64,962.416 1319.89,963.08 1320.1,963.788 1320.32,964.789 1320.66,967.369 1320.84,970.106"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1294.52,960.056 1301.98,958.055 1305.54,957.43 1307.67,957.246 1309.94,957.254 1312.84,957.519 1315.7,957.935"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1273.63,966.119 1294.52,960.056"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1315.17,989.944 1273.63,966.119"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1307.25,1000.04 1303.89,999 1300.59,997.775"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1244.89,965.831 1250.58,967.829 1253.36,968.51 1255.32,968.81 1257.41,968.941 1260.14,968.85 1262.97,968.518 1268.24,967.474 1273.63,966.119"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1300.59,997.775 1244.89,965.831"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1236.57,939.987 1237.17,949.566 1237.57,952.248 1238.14,954.763 1238.79,956.714 1239.45,958.221 1240.49,960.109 1241.55,961.694 1243.18,963.802 1244.89,965.831"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1250.3,894.775 1242.52,910.06 1240.24,915.946 1238.77,921.204 1237.57,928.011 1236.97,934.006 1236.57,939.987"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1288.85,859.282 1275.1,868.333 1268.63,873.587 1263.07,879.111 1256.6,886.695 1250.3,894.775"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1314.26,847.057 1301.59,852.58 1288.85,859.282"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1341.64,838.457 1328.05,842.196 1314.26,847.057"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1397.33,870.4 1341.64,838.457"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1397.33,870.4 1397.35,901.175"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1341.67,874.092 1341.64,838.457"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1395.57,905.012 1341.67,874.092"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1394.28,907.803 1385.51,912.84"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1329.82,880.897 1341.67,874.092"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1385.51,912.84 1329.82,880.897"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1317.96,863.351 1320.07,864.508"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1320.07,864.508 1321.29,865.245 1322.34,865.95 1323.4,866.769 1324.38,867.664 1325.12,868.49 1325.82,869.427 1326.44,870.455 1327,871.564 1327.51,872.743 1328.1,874.408 1329.02,877.584 1329.82,880.897"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1321.56,865.415 1317.96,863.351"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1358.31,897.237 1353.01,899.663 1347.63,902.523"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1291.94,870.58 1301.08,865.937 1304.66,864.555 1307.06,863.883 1309.44,863.462 1312.28,863.241 1315.13,863.24 1317.96,863.351"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1347.63,902.523 1291.94,870.58"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1347.63,902.523 1341.39,906.389 1338.17,908.69 1335.35,911.024"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1271.1,888.117 1277.71,880.919 1280.7,878.176 1282.74,876.545 1284.99,874.925 1288.45,872.686 1291.94,870.58"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1313.44,912.406 1271.1,888.117"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1264.07,908.738 1264.7,902.541 1265.25,899.951 1265.79,898.176 1266.71,895.894 1268.75,892.004 1271.1,888.117"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1284.76,920.607 1264.07,908.738"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1268.93,921.232 1267.43,919.856 1266.73,919.114 1266.25,918.516 1265.77,917.81 1265.42,917.172 1265.15,916.534 1264.91,915.851 1264.72,915.128 1264.52,914.108 1264.22,911.497 1264.07,908.738"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1292.72,918.42 1284.39,920.694 1279.81,921.531 1277.34,921.752 1274.21,921.74 1271.56,921.531 1268.93,921.232"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1313.61,912.357 1292.72,918.42"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1341.74,913.695 1336.27,911.344 1333.71,910.537 1331.73,910.11 1330.02,909.897 1327.87,909.831 1325.82,909.937 1323.02,910.282 1319.82,910.88 1313.61,912.357"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1381.08,936.259 1341.74,913.695"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1350.49,941.404 1350.16,934.774 1349.69,930.149 1349.21,927.371 1348.53,924.776 1347.82,922.834 1346.99,921.09 1345.69,918.901 1343.78,916.237 1341.74,913.695"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1372.77,954.184 1350.49,941.404"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1402.65,996.643 1400.58,1002.01 1396.43,1010.39 1391.66,1018.8"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1335.97,986.855 1344.21,971.59 1346.62,965.699 1348.04,960.945 1349.26,954.758 1350.02,948.076 1350.49,941.404"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1391.66,1018.8 1335.97,986.855"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1391.66,1018.8 1378.22,1034.21 1372.04,1040.12 1364.08,1046.37 1356.52,1051.4 1348.86,1056.08"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1293.17,1024.14 1308.22,1014.55 1315.55,1008.87 1321.9,1002.91 1329,995.127 1335.97,986.855"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1348.86,1056.08 1293.17,1024.14"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1348.86,1056.08 1335.29,1063.2 1321.82,1068.92"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1266.13,1036.98 1279.6,1031.26 1293.17,1024.14"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1321.82,1068.92 1266.13,1036.98"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1321.82,1068.92 1308.01,1073.37 1294.49,1076.41"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1238.8,1044.47 1250.81,1041.83 1258.43,1039.59 1266.13,1036.98"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1158.56,1039.26 1115.38,1064.07"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1137.06,989.925 1158.56,1039.26"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1115.38,1064.07 1137.06,989.925"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1130.09,1178.66 1074.4,1146.71"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1074.39,1133.65 1074.4,1146.71"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1085.76,1127.11 1074.39,1133.65"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1138.06,948.842 1085.76,1127.11"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1160.35,936.035 1138.06,948.842"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1216.04,967.979 1160.35,936.035"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1216.04,967.979 1238.78,1018.97"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1254.05,1053.22 1259.54,1065.54"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1212.96,1054.02 1160.35,936.035"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1226.2,1046.41 1212.96,1054.02"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1281.89,1078.36 1226.2,1046.41"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1281.89,1078.36 1281.9,1091.42"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1226.21,1059.48 1226.2,1046.41"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1281.9,1091.42 1226.21,1059.48"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1281.9,1091.42 1216.72,1128.88"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1161.03,1096.93 1226.21,1059.48"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1216.72,1128.88 1161.03,1096.93"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1161.02,1083.87 1161.03,1096.93"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1174.63,1076.04 1161.02,1083.87"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1163.14,1049.7 1174.63,1076.04"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1176.64,1105.89 1166.51,1111.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1110.82,1079.76 1163.14,1049.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1166.51,1111.7 1110.82,1079.76"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1166.51,1111.7 1159.67,1135.02"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1099.19,1119.39 1110.82,1079.76"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1115.79,1109.86 1099.19,1119.39"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1171.48,1141.8 1115.79,1109.86"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1171.48,1141.8 1171.49,1154.86"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1115.8,1122.92 1115.79,1109.86"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1171.49,1154.86 1115.8,1122.92"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1171.49,1154.86 1130.09,1178.66"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1074.4,1146.71 1115.8,1122.92"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1538.17,535.183 1525.95,542.202"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1558.26,515.429 1552.22,523.688 1549.53,526.685 1546.97,529.035 1544.95,530.637 1542.64,532.286 1538.17,535.183"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1565.28,487.951 1564.65,496.852 1563.94,500.797 1562.93,504.406 1560.79,509.888 1558.26,515.429"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1558.22,468.672 1560.41,470.875 1561.42,472.054 1562.13,472.997 1562.82,474.103 1563.38,475.212 1563.8,476.289 1564.15,477.44 1564.43,478.657 1564.72,480.366 1565.09,484.074 1565.28,487.951"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1538.12,472.121 1544.72,468.932 1546.63,468.227 1548.31,467.757 1549.68,467.506 1550.92,467.406 1552.25,467.428 1553.57,467.568 1554.69,467.764 1555.92,468.043 1558.22,468.672"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1565.27,487.693 1538.12,472.121"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1525.9,479.14 1538.12,472.121"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1563.91,500.94 1525.9,479.14"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1525.95,542.202 1525.9,479.14"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1578.65,524.67 1575.13,524.209 1573.57,524.162 1572.48,524.22 1571.72,524.311 1570.92,524.447 1569.27,524.834 1566.98,525.533 1564.66,526.337"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1637.6,558.224 1638.8,558.978 1639.47,559.476 1640.1,560.022 1640.68,560.589 1641.42,561.402 1642.87,563.288 1644.24,565.295"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1588.54,533.352 1587.07,531.194 1585.93,529.704 1584.88,528.536 1584.03,527.737 1583.53,527.341 1583,526.96 1581.91,526.28"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1581.91,526.28 1580.3,525.44 1578.65,524.67"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1644.24,565.295 1588.54,533.352"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1644.24,565.295 1649.13,573.279"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1608.91,566.592 1588.54,533.352"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1623.18,558.394 1608.91,566.592"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1678.87,590.337 1623.18,558.394"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1678.87,590.337 1678.88,603.403"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1623.19,571.46 1623.18,558.394"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1678.88,603.403 1623.19,571.46"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1678.88,603.403 1633.09,629.713"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1577.4,597.769 1623.19,571.46"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1633.09,629.713 1577.4,597.769"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1555.17,561.821 1577.4,597.769"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1544.19,548.842 1547.76,551.522 1549.18,552.842 1550.48,554.323 1552.02,556.46 1553.64,559.087 1555.17,561.821"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1531.65,551.892 1536.1,549.692 1537.28,549.245 1538.43,548.908 1539.44,548.715 1540.55,548.616 1541.8,548.623 1543,548.712 1544.19,548.842"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1558.58,567.338 1531.65,551.892"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1525.96,555.16 1531.65,551.892"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1564.84,577.46 1525.96,555.16"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1581.66,600.215 1581.68,625.604"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1526,614.228 1525.96,555.16"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1543.91,603.94 1526,614.228"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1599.6,635.883 1543.91,603.94"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1599.6,635.883 1599.61,648.949"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1543.92,617.006 1543.91,603.94"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1599.61,648.949 1543.92,617.006"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1599.61,648.949 1527.99,690.101"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1472.3,658.157 1543.92,617.006"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1527.99,690.101 1472.3,658.157"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1472.29,645.091 1472.3,658.157"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1490.1,634.857 1472.29,645.091"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1490,499.769 1490.1,634.857"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1472.19,510.004 1490,499.769"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1490.02,520.229 1472.19,510.004"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1472.18,496.938 1472.19,510.004"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1551.63,451.285 1472.18,496.938"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1589.08,441.056 1581.29,440.817 1577.31,441.058 1574.6,441.454 1571.55,442.163 1568,443.327 1564.2,444.88 1559.89,446.922 1551.63,451.285"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1647.66,474.567 1650.05,476.064 1651.49,477.177 1652.61,478.212 1653.45,479.163 1654.17,480.127 1654.8,481.179 1655.35,482.324 1655.83,483.555 1656.24,484.862 1656.7,486.711 1657.13,489.099 1657.49,491.902 1657.99,497.434"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1602.3,465.491 1601.29,456.255 1600.72,453.535 1600.1,451.501 1599.51,450.043 1598.94,448.924 1598.33,447.971 1597.59,447.014 1596.76,446.112 1595.86,445.285 1594.91,444.522 1593.48,443.532 1591.97,442.623"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1591.97,442.623 1589.08,441.056"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1657.99,497.434 1602.3,465.491"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1657.99,497.434 1657.18,506.855 1656.35,511.308 1655.31,514.947 1654.35,517.559 1653.14,520.401 1650.98,524.911 1648.64,529.437"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1592.95,497.494 1598.25,486.629 1599.95,481.992 1600.9,478.274 1601.44,475.237 1601.85,471.86 1602.3,465.491"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1648.64,529.437 1592.95,497.494"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1648.64,529.437 1639.86,540.875 1635.76,545.394 1631.82,549.133 1627.75,552.573"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1564.66,526.337 1574.8,518.354 1580.17,513.349 1583.33,509.914 1586.72,505.791 1592.95,497.494"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1303.21,607.096 1320.93,596.915"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1320.95,617.268 1303.21,607.096"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1303.2,594.03 1303.21,607.096"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1374.82,552.878 1303.2,594.03"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1428.3,583.554 1374.82,552.878"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1374.83,565.944 1374.82,552.878"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1428.31,596.62 1374.83,565.944"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1428.31,599.157 1412.71,608.122"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1357.02,576.179 1374.83,565.944"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1412.71,608.122 1357.02,576.179"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1412.71,608.122 1412.76,673.937"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1357.08,656.843 1357.02,576.179"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1365.23,694.349 1361.57,687.615 1360.02,684.001 1359.01,680.863 1358.19,677.067 1357.67,673.333 1357.18,665.262 1357.08,656.843"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1393.02,690.421 1387.57,693.271 1383.68,695.062 1380.9,696.091 1378.72,696.686 1377,696.984 1375.6,697.085 1374.34,697.059 1372.86,696.891 1371.51,696.621 1370.19,696.261 1367.69,695.373 1365.23,694.349"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1420.29,662.6 1415.8,669.637 1412.37,674.453 1409.24,678.165 1406.13,681.202 1401.69,684.758 1397.4,687.68 1393.02,690.421"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1428.33,615.905 1427.93,630.82 1427.01,638.902 1425.42,646.391 1423.04,654.442 1420.29,662.6"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1428.27,535.241 1428.33,615.905"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1410.55,545.422 1428.27,535.241"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1428.28,555.594 1410.55,545.422"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1410.54,532.356 1410.55,545.422"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1459.03,504.493 1410.54,532.356"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1490.02,522.266 1459.03,504.493"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1459.04,517.559 1459.03,504.493"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1490.03,535.332 1459.04,517.559"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1441.23,527.793 1459.04,517.559"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1490.04,555.792 1441.23,527.793"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1441.29,610.725 1441.23,527.793"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1486.74,636.791 1441.29,610.725"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1494.77,671.043 1492.87,678.695 1488.52,690.879 1483.22,703.24"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1427.53,671.297 1436.03,650.369 1438.35,642.428 1439.8,634.906 1440.96,622.738 1441.29,610.725"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1483.22,703.24 1427.53,671.297"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1483.22,703.24 1469.03,721.133 1463.24,727.093 1457.36,732.132 1447.26,739.257 1436.89,745.583"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1381.19,713.64 1397.82,703.081 1405.2,697.266 1410.92,691.803 1419.37,681.99 1427.53,671.297"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1436.89,745.583 1381.19,713.64"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1436.89,745.583 1427.22,750.793 1420.27,754.091 1415.7,755.859 1411.69,757.038 1408.56,757.645 1405.41,757.937 1401.69,757.913 1398.31,757.602 1394.45,757.008 1390.62,756.286"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1334.93,724.343 1341.91,725.566 1345.46,725.937 1349.03,726.018 1352.06,725.806 1354.94,725.333 1357.59,724.676 1360.28,723.822 1363.94,722.418 1372.49,718.358 1381.19,713.64"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1390.62,756.286 1334.93,724.343"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1320.99,679.631 1321.31,690.514 1321.94,698.094 1322.7,702.86 1323.68,706.853 1324.73,709.818 1326.05,712.632 1327.74,715.474 1329.69,718.198 1332.25,721.324 1334.93,724.343"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1320.93,596.915 1320.99,679.631"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1091.87,817.655 1048.7,842.464"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1070.38,768.321 1091.87,817.655"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1048.7,842.464 1070.38,768.321"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1063.4,957.051 1007.71,925.108"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1007.7,912.042 1007.71,925.108"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1019.08,905.505 1007.7,912.042"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1071.37,727.237 1019.08,905.505"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1093.66,714.431 1071.37,727.237"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1149.35,746.374 1093.66,714.431"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1149.35,746.374 1173.45,800.417"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1146.27,832.418 1093.66,714.431"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1159.52,824.809 1146.27,832.418"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1164.46,827.646 1159.52,824.809"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1215.21,864.141 1215.22,869.818"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1159.53,837.875 1159.52,824.809"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1215.22,869.818 1159.53,837.875"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1215.22,869.818 1150.03,907.273"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1094.34,875.329 1159.53,837.875"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1150.03,907.273 1094.34,875.329"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1094.33,862.263 1094.34,875.329"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1107.95,854.44 1094.33,862.263"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1096.45,828.096 1107.95,854.44"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1109.95,884.282 1099.83,890.099"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1044.14,858.156 1096.45,828.096"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1099.83,890.099 1044.14,858.156"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1099.83,890.099 1092.98,913.419"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1032.5,897.789 1044.14,858.156"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1049.1,888.251 1032.5,897.789"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1104.8,920.194 1049.1,888.251"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1104.8,920.194 1104.81,933.26"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1049.11,901.317 1049.1,888.251"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1104.81,933.26 1049.11,901.317"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1104.81,933.26 1063.4,957.051"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1007.71,925.108 1049.11,901.317"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1287.39,1281.14 1226.26,1345.89 1168.53,1396.46 1115.26,1434.95 1066.92,1463.43 1023.58,1483.77 985.07,1497.63 951.061,1506.4 921.164,1511.25 894.963,1513.13 869.543,1512.64 845.009,1509.79 823.769,1505.21 805.394,1499.47 788.123,1492.38 771.621,1483.85"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 771.621,1483.85 753.906,1472.49 737.291,1459.34 721.831,1444.47 707.578,1427.91 694.578,1409.71 682.875,1389.96 672.507,1368.69 663.51,1346 655.913,1321.95 649.74,1296.62 645.014,1270.1 641.748,1242.47 639.686,1204.07 640.508,1159.01 644.651,1112.28 652.084,1064.26 662.751,1015.28 676.572,965.719 699.725,899.373 731.869,825.38 769.943,753.267 813.31,684.244 861.241,619.469 912.931,560.032 967.512,506.93 1024.07,461.054 1075.87,426.585 1122.62,401.491 1164.36,383.95 1201.33,372.384 1233.89,365.466 1261.02,362.211 1287.39,361.414"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1343.08,393.357 1287.39,361.414"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1343.08,393.357 1316.14,394.198 1288.41,397.603 1260.03,403.557 1231.11,412.033 1201.79,422.994 1172.2,436.391 1142.47,452.165 1112.73,470.244 1073.3,497.795 1029.59,533.244 986.998,573.066 945.948,616.86 906.852,664.189 870.102,714.577 836.067,767.519 805.088,822.484 777.476,878.921 753.507,936.263 733.423,993.937 717.423,1051.36 705.67,1107.96 698.281,1163.18 695.329,1216.44 696.845,1267.23 702.813,1315.03 711.942,1355.09 723.14,1388.48 735.571,1416.18 748.608,1439.07 761.792,1457.95 774.793,1473.47 787.334,1486.18 800.681,1497.71"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1373.31,1324.06 1287.39,1281.14"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1429,1356 1373.31,1324.06"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1252.18,1537.48 1313.63,1483.42 1372.82,1422.66 1429,1356"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1196.49,1505.54 1257.94,1451.48 1317.13,1390.72 1373.31,1324.06"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1252.18,1537.48 1196.49,1505.54"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1252.18,1744.07 1252.18,1537.48"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1196.49,1712.12 1196.49,1505.54"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1252.18,1744.07 1196.49,1712.12"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1252.18,1744.07 1029.42,1871.84"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 973.728,1839.9 1196.49,1712.12"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1029.42,1871.84 973.728,1839.9"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 973.728,1633.31 973.728,1839.9"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 833.72,1683.6 862.659,1687.72 892.636,1689.15 923.539,1687.9 948.412,1685.04 973.728,1680.52"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 778.029,1651.66 808.266,1655.89 839.628,1657.21 871.989,1655.59 905.216,1651.06 939.175,1643.62 973.728,1633.31"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 833.72,1683.6 778.029,1651.66"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 707.625,1902 833.72,1683.6"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 651.933,1870.06 778.029,1651.66"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 707.625,1902 651.933,1870.06"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 494.415,1777.93 651.933,1870.06"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 620.51,1559.53 494.415,1777.93"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 539.449,1379.31 550.67,1425.27 563.97,1463.71 578.47,1495.77 595.297,1525.26 607.44,1542.98 620.51,1559.53"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 416.814,1513.54 553.678,1435.04"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 361.123,1481.6 539.449,1379.31"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 416.814,1513.54 361.123,1481.6"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 361.123,1223.53 361.123,1481.6"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 539.449,1121.25 361.123,1223.53"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 620.51,848.046 585.219,939.647 558.052,1031.21 539.449,1121.25"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 494.415,774.295 620.51,848.046"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 651.933,501.467 494.415,774.295"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 707.625,533.411 651.933,501.467"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 707.625,533.411 778.356,574.78"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 778.029,575.218 651.933,501.467"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 973.728,369.064 905.216,429.911 839.628,499.004 778.029,575.218"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 973.728,162.482 973.728,369.064"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1196.49,138 973.728,162.482"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1252.18,169.943 1196.49,138"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1252.18,169.943 1252.18,226.03"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1196.49,241.291 1196.49,138"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1373.31,219.943 1345.64,217.658 1317.13,217.718 1287.87,220.123 1257.94,224.865 1227.45,231.929 1196.49,241.291"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1429,251.886 1373.31,219.943"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1343.08,393.357 1429,251.886"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1287.39,361.414 1373.31,219.943"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1637.6,558.224 1581.91,526.28"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1647.66,474.567 1591.97,442.623"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1320.45,974.926 1294.52,960.056"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: " 1403.45,683.437 1357.08,656.843"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.40167223218c2cac4f6f6f4561f3c18b.svg";
export { ForwardRef as ReactComponent };